import * as inmateAccountPaymentResource from '../../resources/InmateAccountPayment';

export const LOAD_PAYMENT_LOADING = 'AUDIO_VIDEO/RECEIPT/LOAD_PAYMENT_LOADING';
export const LOAD_PAYMENT_SUCCESS = 'AUDIO_VIDEO/RECEIPT/LOAD_PAYMENT_SUCCESS';
export const LOAD_PAYMENT_FAILURE = 'AUDIO_VIDEO/RECEIPT/LOAD_PAYMENT_FAILURE';
export function loadPayment(id: number|string) {
  return dispatch => {
    dispatch({ type: LOAD_PAYMENT_LOADING, id });

    return inmateAccountPaymentResource
      .getAudioVideo(Number(id))
      .then(payment => dispatch({ type: LOAD_PAYMENT_SUCCESS, payment}))
      .catch(error => dispatch({ type: LOAD_PAYMENT_FAILURE, error }))
  }
}

export const RESET = 'AUDIO_VIDEO/RECEIPT/RESET';
export function reset() {
  return { type: RESET };
}
